import {
	FETCH_HOTELS_REQUEST,
	FETCH_HOTELS_SUCCESS,
	RESET_HOTEL_ONLY_BOOKING_FLOW_ID,
} from "./hotelOnlyActionCreator";
import { CLEAR_SMARTDP } from "app/pages/SmartDP/smartDPActionTypes";

const initialState = {
	hotels: [],
	isLoading: true,
	metadata: {
		pagination: {
			totalItems: 0,
		},
	},
	bookingFlowId: null,
	facets: null,
};

const hotelOnlyReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_HOTELS_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null,
			};

		case FETCH_HOTELS_SUCCESS: {
			const { data, metadata } = action.res.data;

			return {
				...state,
				isLoading: false,
				hotels: data,
				metadata: {
					pagination: {
						totalItems: metadata.pagination.totalItems,
					},
				},
				facets: metadata.facets,
				bookingFlowId: metadata.bookingFlowId,
				error: null,
			};
		}

		case RESET_HOTEL_ONLY_BOOKING_FLOW_ID: {
			return { ...state, bookingFlowId: undefined };
		}
		case CLEAR_SMARTDP: {
			// clear hotel only state when user goes to home page. This is to enable merch redirecting to listing to open on same tab.
			return { ...initialState };
		}
		default:
			return state;
	}
};

export default hotelOnlyReducer;
